module.exports = __webpack_public_path__ + "media/images/logo-white-with-name-122032edcfbd22ab4ffea3f2b454b7cf.png";